"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp, _dec, _class2, _class3, _temp2;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRedux = require("react-redux");

var _auth = require("redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _redux = require("redux");

var _reactRouter = require("react-router");

var _components = require("components");

var _subscriptions = require("redux/modules/subscriptions");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MiniProfileBar = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(MiniProfileBar, _React$Component);

  function MiniProfileBar() {
    (0, _classCallCheck3.default)(this, MiniProfileBar);
    return (0, _possibleConstructorReturn3.default)(this, (MiniProfileBar.__proto__ || (0, _getPrototypeOf2.default)(MiniProfileBar)).call(this));
  }

  (0, _createClass3.default)(MiniProfileBar, [{
    key: "onTopupClick",
    value: function onTopupClick() {
      this.context.dialogs.custom(_react2.default.createElement(_components.TopupDialog, null));
    }
  }, {
    key: "handleLogoutSubmit",
    value: function handleLogoutSubmit(ev) {
      var _this2 = this;

      ev.preventDefault();

      this.props.logout().then(function () {
        _this2.context.router.replace("/login");
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames;

      var _props$user = this.props.user,
          loading = _props$user.loading,
          name = _props$user.name,
          email = _props$user.email,
          quota = _props$user.quota,
          subscription = _props$user.subscription;
      var loggingOut = this.props.auth.loggingOut;

      var styles = require("./MiniProfileBar.scss");

      var plan = subscription && subscription.planName;

      var miniProfileClasses = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.MiniProfileBar, true), (0, _defineProperty3.default)(_classnames, styles["MiniProfileBar--loading"], loading), _classnames));

      return _react2.default.createElement(
        "div",
        { className: miniProfileClasses },
        loading || loggingOut ? _react2.default.createElement(_components.LoadingIndicator, null) : null,
        !loading && !loggingOut && quota ? _react2.default.createElement(
          "div",
          { className: styles.MiniProfileBar__profile },
          _react2.default.createElement(
            "div",
            { className: styles.MiniProfileBar__name },
            name || email,
            _react2.default.createElement(
              "div",
              { className: styles.MiniProfileBar__field },
              plan ? _react2.default.createElement(
                "div",
                {
                  className: styles["MiniProfileBar__subscription-info-box"]
                },
                _react2.default.createElement(
                  "div",
                  {
                    className: styles["MiniProfileBar__subscription-info"]
                  },
                  _react2.default.createElement(
                    "span",
                    null,
                    quota.currentQuota
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { style: { textAlign: "center" } },
                  _react2.default.createElement(
                    "span",
                    null,
                    "POINTS"
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { style: { padding: "20px 0 8px 0" } },
                  _react2.default.createElement(_components.Button, {
                    primary: true,
                    fullWidth: true,
                    label: "Top-up points",
                    onClick: this.onTopupClick.bind(this)
                  })
                )
              ) : _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: styles["MiniProfileBar__subscribe-now"],
                  to: "/pricing"
                },
                "Subscribe Now"
              )
            )
          ),
          _react2.default.createElement(
            "div",
            { className: styles.MiniProfileBar__links },
            _react2.default.createElement(
              "div",
              (0, _defineProperty3.default)({
                className: styles["MiniProfileBar__field-inner"]
              }, "className", styles["pull-left"]),
              _react2.default.createElement(
                "div",
                { className: styles["MiniProfileBar__field-link"] },
                _react2.default.createElement("img", {
                  className: styles.MiniProfileBar__icon,
                  src: "/icons/user.svg"
                }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: "/profile" },
                  "My Profile"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: styles["MiniProfileBar__field-link"] },
                _react2.default.createElement("img", {
                  className: styles.MiniProfileBar__icon,
                  src: "/icons/logout.svg"
                }),
                _react2.default.createElement(
                  "a",
                  { href: "#", onClick: this.handleLogoutSubmit.bind(this) },
                  "Sign out"
                )
              )
            )
          )
        ) : null
      );
    }
  }]);
  return MiniProfileBar;
}(_react2.default.Component), _class.contextTypes = {
  user: _react2.default.PropTypes.object,
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);
var MiniProfileBarContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.user,
    auth: state.auth
  };
}), _dec(_class2 = (_temp2 = _class3 = function (_React$Component2) {
  (0, _inherits3.default)(MiniProfileBarContainer, _React$Component2);

  function MiniProfileBarContainer() {
    (0, _classCallCheck3.default)(this, MiniProfileBarContainer);
    return (0, _possibleConstructorReturn3.default)(this, (MiniProfileBarContainer.__proto__ || (0, _getPrototypeOf2.default)(MiniProfileBarContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(MiniProfileBarContainer, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          dispatch = _props.dispatch,
          user = _props.user,
          auth = _props.auth,
          plans = _props.plans;


      return _react2.default.createElement(MiniProfileBar, (0, _extends3.default)({
        user: user,
        auth: auth,
        plans: plans
      }, (0, _redux.bindActionCreators)(authActions, dispatch)));
    }
  }]);
  return MiniProfileBarContainer;
}(_react2.default.Component), _class3.propTypes = {
  dispatch: _react2.default.PropTypes.func
}, _temp2)) || _class2);
exports.default = MiniProfileBarContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MiniProfileBar/MiniProfileBar.jsx
// module id = 2370
// module chunks = 0